import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const SidebarItem = ({
    url,
    // All base and hover classes for the Link are now in this default string
    className = "flex items-center p-3 text-xl rounded-lg group  hover:bg-sidebar-hover",
    value,
    IconComponent
}) => {
     const location = useLocation(); 
    const isActive = location.pathname === url;
    return (
        <li>
            <Link
                to={url}
                className={`${className} ${isActive ? 'bg-sidebar-hover' : ''}`}
            >
                {IconComponent && (
                    <IconComponent
                        className="w-5 transition duration-75"
                    />
                )}
                <span
                    className="
                        pl-2                    "
                >
                    {value}
                </span>
            </Link>
        </li>
    );
};

export default SidebarItem;